import React, { useEffect, useState } from "react";
import { Moment } from "moment";
import _ from "lodash";

import { LabMachineAnalysisFiletersForm } from "../..";
import { applyFilter } from "./applyFilter";
import { Charts } from "./Charts";
import { Sample } from "./types";

export const MachineSamplesTableMap = ({
  data,
  subUnit,
  showChart,
}: {
  data: Sample[];
  subUnit?: "engine" | "component";
  showChart?: boolean;
}): React.ReactElement => {
  const [dataToShow, setDataToShow] = useState<
    {
      machine: string;
      samples: { id: string; date: string; state: string }[];
    }[]
  >([]);
  const [dataChart, setDataChart] = useState<Sample[]>([]);

  useEffect(() => {
    setDataToShow([]);
  }, [data]);

  const handleFilter = (form: {
    sampleDates: [null | Moment, null | Moment];
    states: string[];
    machines: string[];
  }) => {
    const dataFiltered = applyFilter(data, form);
    const machineMap = dataFiltered.reduce(
      (acc, { id, equipo_componente, fecha_muestra, estado }) => ({
        ...acc,
        [equipo_componente]: acc[equipo_componente]
          ? [
              ...acc[equipo_componente],
              { id, date: fecha_muestra, state: estado },
            ]
          : [{ id, date: fecha_muestra, state: estado }],
      }),
      {},
    ) as {
      machine: string;
      samples: { id: string; date?: string; state: string }[];
    };

    let machinesList = _.reduce(
      machineMap,
      (acc, value, key) => [
        ...acc,
        {
          machine: key,
          samples: _.sortBy(value, (i: any) => !i.date), // Se ordenan samples por fecha de mayor a menor
        },
      ],
      [],
    );

    machinesList = _.sortBy(machinesList, (i) => i.machine);
    setDataToShow(machinesList);
    setDataChart(dataFiltered);
  };

  return (
    <>
      <LabMachineAnalysisFiletersForm
        registers={data}
        onSubmit={handleFilter}
      />

      <table style={styles.table}>
        {dataToShow.map(({ machine, samples }) => (
          <tr key={machine}>
            <th style={styles.th}>{machine}</th>
            {samples.map((sample) => (
              <td key={sample.id} style={styles.td(sample)}>
                <span className="flex-col">
                  <div>{sample.date}</div>
                  <div>{sample.id}</div>
                </span>
              </td>
            ))}
          </tr>
        ))}
      </table>

      {showChart && <Charts data={dataChart} type={subUnit} />}
    </>
  );
};

const STATE_COLORS = {
  NORMAL: "rgba(0,255,0,.3)",
  PRECAUCION: "rgba(255,246,0,.3)",
  CRITICO: "rgba(255,0,0,.3)",
};

const styles = {
  table: {
    display: "inline-block",
    overflowX: "auto",
    overflowY: "auto",
    maxHeight: "30em",
    width: "100%",
    marginTop: "20px",
  } as React.CSSProperties,
  th: {
    position: "sticky",
    backgroundColor: "#f8f8f8",
    minWidth: "7em",
  } as React.CSSProperties,
  td: ({ state }) => ({
    backgroundColor: STATE_COLORS[state],
    padding: "1em",
    minWidth: "9em",
  }),
};
